export const UNAVAILABLE = 0;
export const COMPUTED = 1;
export const ERROR = 2;
